import { useEffect, useState, useContext } from "react";
import MaterialDetailLayout from "../components/MaterialDetailLayout";
//import MaterialModal from "../components/MaterialModal";

//import "swiper/swiper.min.css";
import { MaterialContext } from "../context/MaterialContext";
import { UserContext } from "../context/UserContext";
import { useParams, useNavigate } from "react-router-dom";
import singleStyle from "../styles/single.module.scss";
import FilteredLibrary from "../components/FilteredLibrary";
import MaterialViewCount from "../utilities/MaterialViewCount";
import ImageDownload from "../utilities/ImageDownload";
//import SwipeImages from "../components/SwipeImages";

function SingleMaterial() {
  const { allMaterials, ROOT_SERVER } = useContext(MaterialContext);
  const { userInformation, media } = useContext(UserContext);
  const [materialData, setMaterialData] = useState([]);
  const [materialDataLoaded, setMaterialDataLoaded] = useState(false);
  const [imageNumber, setImageNumber] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [imageDownload, setImageDownload] = useState(false);
  const [error, setError] = useState(false);
  //const [isSwiper, setIsSwiper] = useState(false);
  const [isFailed, setIsFailed] = useState(false);

  const { vendor, slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const getMaterialData = allMaterials.filter(
      (mat) => mat.vendor === vendor && mat.slug === slug,
    );
    if (getMaterialData.length === 1) {
      setError(false);
      setMaterialData(getMaterialData[0]);
      setMaterialDataLoaded(true);
    } else {
      setError(true);
      setMaterialDataLoaded(false);
    }
    // eslint-disable-next-line
  }, [allMaterials, vendor, slug]);

  useEffect(() => {
    MaterialViewCount(materialData.id);
  }, [materialData.id]);

  useEffect(() => {
    if (materialDataLoaded) {
      setIsFailed(false);
      setLoaded(true);
      setImageLoaded(false);
      setImageNumber(0);
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      return;
    }

    setLoaded(false);
  }, [materialDataLoaded, slug, vendor]);

  const handleImageLoaded = () => {
    setImageLoaded(true);
  };
  const handleChangeImage = (i) => {
    if (i !== imageNumber) {
      setImageLoaded(false);
      setImageNumber(i);
    }
  };

  const handleEdit = (vendor, slug) => {
    navigate(`../material/edit/${vendor}/${slug}`);
  };

  const handleBackToLibrary = () => {
    navigate("/library");
  };

  const getViewingImage = (material, i) => {
    if (!material) {
      return "";
    }

    const imageSet = Array.isArray(material.images) ? material.images : [];
    const safeImage = imageSet[i] || imageSet[0] || "";

    return `${ROOT_SERVER}${material.vendor}/${material.slug}/${
      media === "mobile" ? "swatch" : "full"
    }/${safeImage}`;
  };

  const handleDownloadImage = (vendor, slug) => {
    ImageDownload(getViewingImage(materialData, imageNumber), vendor, slug);
    setImageDownload(true);
    setTimeout(() => {
      setImageDownload(false);
    }, 3000);
  };

  const { userId, isLoggedIn } = userInformation;

  if (!userId && !isLoggedIn) {
    if (loaded && materialData && !isFailed) {
      const { id, title, subtype, character, vendor, slug } = materialData;

      return (
        <div className="content">
          <div className={singleStyle.singlePageWrap}>
            <MaterialDetailLayout
              materialData={materialData}
              ROOT_SERVER={ROOT_SERVER}
              viewing={getViewingImage(materialData, imageNumber)}
              imageNumber={imageNumber}
              onChangeImage={handleChangeImage}
              imageLoaded={imageLoaded}
              onImageLoaded={handleImageLoaded}
              onClose={handleBackToLibrary}
              closeLabel="Back"
              canEdit={false}
              onPrimaryAction={() => null}
              primaryLabel="Add to collection"
              onSecondaryAction={() => handleDownloadImage(vendor, slug)}
              secondaryLabel="Download Image"
              secondaryLoadingLabel="Downloading"
              secondaryIsLoading={imageDownload}
              brandData={[]}
              showBrandData={false}
              mode="page"
            />
          </div>
          <div className={singleStyle.singleSimilar}>
            <FilteredLibrary
              id={id}
              terms={character}
              title={title}
              allMaterials={allMaterials}
              control={subtype.toLowerCase()}
            />
          </div>
        </div>
      );
    }

    return (
      <>
        {!isFailed && materialData ? (
          <div className="content">
            <div className="loaderUp">
              <h3>{vendor.replaceAll("-", " ").toUpperCase()}</h3>
              <h2>{slug.replaceAll("-", " ").toUpperCase()}</h2>
              <div className="spinner" />
            </div>
          </div>
        ) : (
          <div className="content">
            <div className="empty-collection">
              <div className="empty-collection-message">
                <div className="text-box">
                  <h2 className="login-view-heading">
                    Can't find {slug} from {vendor}
                  </h2>
                  <button className="button" onClick={handleBackToLibrary}>
                    return to library
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }

  if (loaded && materialData && !error) {
    const { id, title, slug, vendor, subtype, character, view_count } =
      materialData;

    return (
      <div className="content">
        <div className={singleStyle.singlePageWrap}>
          <MaterialDetailLayout
            materialData={materialData}
            ROOT_SERVER={ROOT_SERVER}
            viewing={getViewingImage(materialData, imageNumber)}
            imageNumber={imageNumber}
            onChangeImage={handleChangeImage}
            imageLoaded={imageLoaded}
            onImageLoaded={handleImageLoaded}
            onClose={handleBackToLibrary}
            closeLabel="Back"
            onEdit={() => handleEdit(vendor, slug)}
            canEdit={userInformation.userType === "vendor"}
            editMeta={`view Count: ${view_count}`}
            onPrimaryAction={() => null}
            primaryLabel="Add to collection"
            onSecondaryAction={() => handleDownloadImage(vendor, slug)}
            secondaryLabel="Download Image"
            secondaryLoadingLabel="Downloading"
            secondaryIsLoading={imageDownload}
            brandData={[]}
            showBrandData={false}
            mode="page"
          />
        </div>
        <div className={singleStyle.singleSimilar}>
          <FilteredLibrary
            id={id}
            terms={character}
            vendor={vendor}
            title={title}
            allMaterials={allMaterials}
            control={subtype.toLowerCase()}
          />
        </div>
      </div>
    );
  }

  return (
    <>
      {!isFailed && materialData ? (
        <div className="content">
          <div className="loaderUp">
            <h3>{vendor.replaceAll("-", " ").toUpperCase()}</h3>
            <h2>{slug.replaceAll("-", " ").toUpperCase()}</h2>
            <div className="spinner" />
          </div>
        </div>
      ) : (
        <div className="content">
          <div className="empty-collection">
            <div className="empty-collection-message">
              <div className="text-box">
                <h2 className="login-view-heading">
                  Can't find {slug} from {vendor}
                </h2>
                <button className="button" onClick={handleBackToLibrary}>
                  return to library
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default SingleMaterial;
